import React, { Fragment } from 'react';

interface OnboardingQuickStartTourProps {
  submit: () => void;
}

const OnboardingQuickStartTour: React.FC<OnboardingQuickStartTourProps> = ({ submit }) => {
  return (
    <>
      <div className="bg-white max-w-lg font-sofiaSans px-4 sm:px-0">
        <div className="text-start">
          <h2 className="text-2xl sm:text-3xl font-bold text-center text-black mb-4 sm:mb-5">
            Take a Quick Tour
          </h2>
          <div className="mt-2">
            <p className="text-sm text-secondaryStoryBlackText leading-relaxed mb-3">
              Want a quick tour of your portal? We’ll show you the basics so you’re ready to go. Takes under 2 minutes.
            </p>
          </div>
        </div>
      </div>
      <div className="w-full bg-white py-2 flex justify-center items-center gap-2 sm:gap-0 px-4 sm:px-0">
        <button
          className={`px-6 py-2 h-9 bg-secondaryStoryAdditionalLightBlueText text-whiteText font-bold leading-none rounded-2xl hover:shadow-md transition-shadow flex items-center justify-center text-sm sm:text-base w-full sm:w-auto`}
          onClick={() => submit()}
        >
          Start Tour
        </button>
      </div>
    </>
  );
};

export default OnboardingQuickStartTour;
